<template>
  <div class="animated fadeIn">
    <transition name="fade">
      <loading v-show="isLoading"></loading>
    </transition>
    <b-modal
      size="lg"
      @close="hideModal"
      ref="modal-formAttCadastroPessoa"
      scrollable
      centered
      hide-header-close
      no-close-on-backdrop
    >
      <template #modal-title>
        <i class="fas fa-exclamation-triangle"></i> Atualização cadastral
      </template>
      <div class="form-group row">
        <div class="col-md-3">
          <NxInputDocument
            @update:value="handleInputUpdate('document', $event)"
            @tipoPessoa="setTipoPessoaField"
          />
        </div>
      </div>

      <div class="form-group row pt-2">
        <div class="col-md-4">
          <NxSelectTipoPessoa
            @update:value="handleSelectUpdate('tipoPessoa', $event)"
            v-model="dataForm.tipoPessoa"
          />
        </div>
        <div class="col-md-8">
          <NxInputNome
            @update:value="handleInputUpdate('nomeCompleto', $event, false)"
            v-model="dataForm.nome"
          />
        </div>
      </div>

      <div class="form-group row pt-2">
        <div class="col-md-8">
          <NxInputEmail
            @update:value="handleInputUpdate('email', $event, false)"
            v-model="dataForm.email"
          />
        </div>
        <div class="col-md-4">
          <NxInputDate
            variable="de Nascimento"
            :maxToday="true"
            @update:value="handleInputUpdate('dataNascimento', $event, false)"
            v-model="dataForm.dataNascimento"
          />
        </div>
      </div>
      <template #modal-footer>
        <div
          style="gap: 0.5rem"
          class="d-flex align-end"
        >
          <DefaultButton
            :disabled="isLoading"
            btnVariant="btn-danger"
            :onClick="abort"
            text="Cancelar"
          />
          <DefaultButton
            :disabled="isLoading"
            btnVariant="btn-third"
            :onClick="onSave"
            text="Continuar"
          />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools'
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import Loading from '@/components/UI/Loading'
import DefaultButton from '@/components/UI/button/defaultButton.vue'

import {
  NxInputDate,
  NxInputDocument,
  NxInputEmail,
  NxInputNome
} from '@/components/nexum/components/custom-inputs/index.js'

import { NxSelectTipoPessoa } from '@/components/nexum/components/custom-selects/index.js'

import PersonRepository from '@/shared/http/repositories/configurations/person.js'

export default {
  name: 'FormAttCadastroPessoaModal',
  mixins: [ActionsForm],
  components: {
    Loading,
    DefaultButton,

    NxInputDocument,
    NxSelectTipoPessoa,
    NxInputNome,
    NxInputEmail,
    NxInputDate
  },
  data () {
    return {
      dataForm: {
        document: null,
        tipoPessoa: null,
        nome: null,
        email: null,
        dataNascimento: null
      }, // dataForm a ser mandando na request para o backend
      pessoaId: null, // ID da pessoa a ser atualizado
      isLoading: false, // Indica se há uma operação em andamento
      resolvePromise: null, // Função de resolução da Promise
      rejectPromise: null // Função de rejeição da Promise
    }
  },
  methods: {
    /**
     * Exibe o modal e inicializa o ID da pessoa.
     * Retorna uma Promise para controle externo.
     * @param {Number} pessoaId - ID da pessoa a ser atualizada.
     * @returns {Promise} Promise que será resolvida ou rejeitada.
     */
    async showModal (pessoaId) {
      this.$refs['modal-formAttCadastroPessoa'].show()
      this.pessoaId = pessoaId
      await this.loadPessoaInfo(pessoaId)

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    /**
     * Oculta o modal.
     */
    hideModal () {
      this.$refs['modal-formAttCadastroPessoa'].hide()
    },

    /**
     * Carrega os dados da pessoa para a atualização.
     * @param {Number} pessoaId - ID da pessoa a ser atualizada.
     */
    async loadPessoaInfo (pessoaId) {
      try {
        loading.push()
        this.isLoading = true

        const { status, data } = await PersonRepository.GetById(pessoaId)

        if (status === 200 && data) {
          this.dataForm = data
        }
      } catch (error) {
        this.advancedOnException(error)
      } finally {
        loading.pop()
        this.isLoading = false
      }
    },

    /**
     * Cancela a operação e rejeita a Promise com uma mensagem padrão.
     */
    abort () {
      if (this.rejectPromise) {
        this.rejectPromise(
          new CustomError('Usuário cancelou a atualização cadastral.', {
            cause: 'action_canceled',
            level: 'warning',
            title: 'Operação cancelada'
          })
        )
      }
      this.hideModal()
    },

    /**
     * Salva os dados da pessoa no sistema.
     * Realiza validações e lida com o estado de carregamento.
     */
    async onSave () {
      try {
        this.isLoading = true

        // Define quais campos do dataForm são obrigatórios
        const requiredFields = [
          {
            name: 'document',
            message: 'CPF/CNPJ'
          },
          {
            name: 'tipoPessoa',
            message: 'Tipo de pessoa'
          },
          {
            name: 'nomeCompleto',
            message: 'Nome completo'
          }
        ]

        this.validarCamposObrigatorios(requiredFields)

        const { status, data } = await PersonRepository.Update(this.dataForm)

        console.log('Data: ', data)

        if (status === 200 && data) {
          createNewFollowupWithCard(
            data.document,
            'sys_atualizacao_cadastral',
            'O cadastro de ' + data.nomeAssociado + ' foi atualizado! ',
            this.ip,
            this.latitude,
            this.longitude,
            null
          )
          this.resolvePromise()
        }

        this.hideModal()
      } catch (error) {
        if (error.cause === 'required_fields') {
          this.advancedOnException(error)
          return
        }

        console.error('Erro durante o salvamento:', error)

        // Rejeita a Promise em caso de erro
        if (this.rejectPromise) {
          this.rejectPromise(error)
        }

        this.hideModal()
      } finally {
        this.isLoading = false
      }
    },

    /**
     * Lida com o valor inputado pelo usuario nos campos de input para colocar no form
     * @param {String} fieldName - O nome do campo a ser atualizado
     * @param {String} inputedValue - O valor inputado pelo usuário
     * @param {Boolean} clean - Se o valor deve ser limpo antes de ser atribuido ao campo
     */
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        const value = clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
        this.setField(fieldName, value)
      } else {
        this.clearField(fieldName)
      }
    },

    /**
     * Lida com o valor selecionado pelo usuario nos campos de select para colocar no form
     * @param {String} fieldName - O nome do campo a ser atualizado
     * @param {Object} selectedValue - O valor selecionado pelo usuário
     */
    handleSelectUpdate (fieldName, selectedValue) {
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.setField(fieldName, selectedValue)
      } else if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
      } else if (selectedValue) {
        const value = Array.isArray(selectedValue)
          ? selectedValue.map((v) => v.value)
          : selectedValue.value
        this.setField(fieldName, value)
      } else {
        this.clearField(fieldName)
      }
    },

    /**
     * limpa o form para um campo específico.
     * @param {String} fieldName - O nome do campo a ser limpo
     */
    clearField (fieldName) {
      this.setField(fieldName, null)
    },

    /**
     * Seta um valor no form para um campo específico.
     * @param {String} filedName - O nome do campo a ter um valor atribuido
     * @param {Object} value - O valor a ser atribuido ao campo
     */
    setField (fieldName, value) {
      const keys = fieldName.split('.')
      const lastKey = keys.pop()
      const target = keys.reduce((obj, key) => {
        if (!(key in obj)) obj[key] = {}
        return obj[key]
      }, this.dataForm)
      target[lastKey] = value
    },
    setTipoPessoaField (val) {
      if (val) this.dataForm.tipoPessoa = val
    }
  }
}
</script>

<style lang="scss">
.warn {
  &__tittle {
    color: #f00;
    font-size: 1rem;
    font-weight: 600;
  }
  &__subtitle {
    color: #505050;
    font-size: 1rem;
    font-weight: 400;
  }
  hr {
    margin: 1.25rem 1rem;
  }
}
</style>

<style scoped>
v-select {
  border-radius: 0% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/UI/attCadastroPessoaModal/FormAttCadastroPessoaModal.vue